import assetPath from '/app/packages/lebenslauf/articles/src/assets/tabellarischer-lebenslauf.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')